export enum ProductUnitEnum {
  /** 商品コード */ PRODUCT_CODE = '1',
  /** JANコード */ JAN_CODE = '2',
}

export const ProductUnit = [
  { label: '商品コード', value: ProductUnitEnum.PRODUCT_CODE },
  { label: 'JANコード', value: ProductUnitEnum.JAN_CODE },
];
